import React from 'react';
import { classCombine } from 'Utils/Utils';
import './PageSubTitle.css';

const PageSubTitle = ({ text, alignText = 'left', customClass = '' }) => {
  return <h2 className={classCombine('pageSubTitle', alignText, customClass)}>{text}</h2>;
};

export default PageSubTitle;
